import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { EmergencyContact } from '../../types/user';

const initialState: EmergencyContact = {
  contactName: '',
  contactPhone: '',
  contactRelationship: '',
};

export const emergencyContactSlice = createSlice({
  name: 'emergencyContact',
  initialState,
  reducers: {
    setEmergencyContact: (_, action: PayloadAction<EmergencyContact>) => {
      return action.payload;
    },
    clearEmergencyContact: () => initialState,
  },
});

export const { setEmergencyContact, clearEmergencyContact } = emergencyContactSlice.actions;
export default emergencyContactSlice.reducer;
